import React from "react";

const Terms: React.FC = () => (
  <div className="min-h-screen px-6 py-12">
    <div className="max-w-3xl mx-auto bg-white rounded-lg p-10 border border-border font-body text-ink">
      <h1 className="text-4xl font-bold font-display mb-6">Terms of Service</h1>
      <p className="text-gray-500 mb-8">Last updated: 5 October 2026</p>

      <h2 className="text-2xl font-semibold mb-2">1. Acceptance</h2>
      <p className="mb-6">
        By creating an account you agree to these Terms and to our{" "}
        <a href="/privacy" className="text-primary underline">Privacy Policy</a>.
      </p>

      <h2 className="text-2xl font-semibold mb-2">2. The service</h2>
      <p className="mb-6">
        Exam Revision provides AI-generated practice questions, quizzes, and progress tracking for exam preparation, available
        on a paid monthly subscription.
      </p>

      <h2 className="text-2xl font-semibold mb-2">3. Subscriptions and payment</h2>
      <p className="mb-6">
        Subscription fees are billed monthly via Stripe at the rate shown at signup for your country. Access continues for
        the period you've paid for. There's no separate cancellation step: if you don't renew, your account simply
        reverts to inactive at the end of the paid period. We don't currently offer refunds for unused time.
      </p>

      <h2 className="text-2xl font-semibold mb-2">4. Your account</h2>
      <p className="mb-6">
        You're responsible for keeping your password confidential and for all activity under your account. Tell us immediately
        if you suspect unauthorised access.
      </p>

      <h2 className="text-2xl font-semibold mb-2">5. Acceptable use</h2>
      <p className="mb-6">
        Don't share your account credentials, attempt to disrupt the service, or use it for anything unlawful.
      </p>

      <h2 className="text-2xl font-semibold mb-2">6. Termination</h2>
      <p className="mb-6">
        You may stop using the service and request account deletion at any time. We may suspend or terminate accounts that
        breach these Terms.
      </p>

      <h2 className="text-2xl font-semibold mb-2">7. Liability</h2>
      <p className="mb-6">
        The service is provided "as is". Practice questions and explanations are AI-generated and provided for exam
        preparation purposes only; we don't guarantee specific exam outcomes.
      </p>

      <h2 className="text-2xl font-semibold mb-2">8. Governing law</h2>
      <p>
        These Terms are governed by the laws of England and Wales, and any dispute is subject to the exclusive
        jurisdiction of the courts of England and Wales.
      </p>
    </div>
  </div>
);

export default Terms;
